import { useLocale } from 'next-intl'
import type { LocalizeDateOptions, LocalizeMillisecondsToDaysProps } from '@/shared/utils/dateUtils'
import { localizeDate, localizeMillisecondsToDays } from '@/shared/utils/dateUtils'
import type { LocalizeAmountsOptions, LocalizeMonthProps, LocalizeCountryProps } from '@/shared/utils/localizeUtils'
import { localizeAmounts, localizeCountry, localizeMonth } from '@/shared/utils/localizeUtils'
import type { Currency } from '@/shared/models/moneyModel'

export const useLocalization = () => {
    const locale = useLocale()
    return {
        localizeDate: (
            date: number | Date | string | undefined,
            options?: { dateFormatOptions?: LocalizeDateOptions }
        ) => localizeDate(date, { ...options, locale }),
        localizeMillisecondsToDays: (props: Omit<LocalizeMillisecondsToDaysProps, 'locale'>) =>
            localizeMillisecondsToDays({ ...props, locale }),
        localizeAmounts: (
            amount: number | string | undefined | null,
            currency: Currency | null | undefined,
            options?: Omit<LocalizeAmountsOptions, 'locale'>
        ) => localizeAmounts(amount, currency, { ...options, locale }),
        localizeCountry: (props: Omit<LocalizeCountryProps, 'locale'>) => localizeCountry({ ...props, locale }),
        localizeMonth: (props: Omit<LocalizeMonthProps, 'locale'>) => localizeMonth({ ...props, locale }),
        locale
    }
}
